import api from "@/lib/apiClient";

export const schoolApi = {
  list: () => api.get("/api/schools"),
  create: (payload) => api.post("/api/schools", payload),
};

export const frameworkApi = {
  list: () => api.get("/api/frameworks"),
  get: (frameworkType) => api.get(`/api/frameworks/${frameworkType}`),
  currentSelection: () => api.get("/api/frameworks/selection/current"),
  saveSelection: (payload) => api.post("/api/frameworks/selection", payload),
  uploadRubric: (formData) =>
    api.post("/api/frameworks/upload-rubric", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  listCustomDomains: () => api.get("/api/frameworks/custom-domains"),
  createCustomDomain: (payload) => api.post("/api/frameworks/custom-domains", payload),
  addCustomElement: (domainId, payload) =>
    api.post(`/api/frameworks/custom-domains/${domainId}/elements`, payload),
  deleteCustomDomain: (domainId) =>
    api.delete(`/api/frameworks/custom-domains/${domainId}`),
};

export const recordingPolicyApi = {
  list: () => api.get("/api/recording-policies"),
  create: (payload) => api.post("/api/recording-policies", payload),
  update: (id, payload) => api.patch(`/api/recording-policies/${id}`, payload),
};

export const recordingComplianceApi = {
  get: (teacherId) =>
    api.get("/api/recording-compliance", { params: { teacher_id: teacherId } }),
  summary: () => api.get("/api/recording-compliance/summary"),
  remind: (teacherId) =>
    api.post(
      "/api/recording-compliance/remind",
      new URLSearchParams({ teacher_id: teacherId })
    ),
};

export const curriculumApi = {
  upload: (formData) =>
    api.post("/api/curricula", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  list: (teacherId) =>
    api.get("/api/curricula", { params: { teacher_id: teacherId } }),
  // PLAN-1 C3: admin school-scoped curriculum listing + delete.
  listSchool: (schoolId) =>
    api.get("/api/curricula", { params: { school_id: schoolId } }),
  remove: (id) => api.delete(`/api/curricula/${id}`),
  // PLAN-1b: reference-based sharing (publish-down).
  sharedWithMe: () => api.get("/api/curricula/shared-with-me"),
  shareState: (id) => api.get(`/api/curricula/${id}/share`),
  share: (id, payload) => api.post(`/api/curricula/${id}/share`, payload),
  unshare: (id) => api.delete(`/api/curricula/${id}/share`),
};

export const lessonPlanApi = {
  upload: (formData) =>
    api.post("/api/lesson-plans", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  list: (teacherId, date) =>
    api.get("/api/lesson-plans", { params: { teacher_id: teacherId, date } }),
  // PLAN-1 C2: single-plan preview (extracted text) + owner-guarded delete.
  get: (id) => api.get(`/api/lesson-plans/${id}`),
  remove: (id) => api.delete(`/api/lesson-plans/${id}`),
  // PLAN-3: set/clear a plan's explicit linked recording (owner-guarded both sides). Pass null to unlink.
  linkVideo: (id, videoId) => api.patch(`/api/lesson-plans/${id}`, { linked_video_id: videoId }),
};

export const syllabusApi = {
  upload: (formData) =>
    api.post("/api/syllabi", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  list: (teacherId) =>
    api.get("/api/syllabi", { params: { teacher_id: teacherId } }),
};
